import React, { useEffect, useRef, useState } from "react";
import "./CareerPage.scss";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import { InputMask } from "primereact/inputmask";
import { AiOutlineCheckCircle } from "react-icons/ai";
import Nav from "../../Home/navbar/nav";
import { Helmet } from "react-helmet";

const CareerPage = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    location: "",
    position: "",
    experience: "",
    base64Data: "",
    resumeFileName: "",
    resumeContentType: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pdfData, setPdfData] = useState("");
  const [errorData, setErrorData] = useState("");

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const fileUploadRef = useRef(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const onSelect = (e) => {
    const file = e.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result.split(",")[1];
        setPdfData(base64);
        setFormData((prev) => ({
          ...prev,
          base64Data: base64,
          resumeFileName: file.name,
          resumeContentType: file.type,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return; // Prevent further clicks
    setIsSubmitting(true); // Lock submit button
    if (!pdfData) {
      setErrorData("Please Upload Your Resume.");
      setIsSubmitting(false); // Allow retry if resume not uploaded

      return;
    }

    setErrorData("");

    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phone: `+91 ${formData.phoneNumber}`,
      applyingFor: formData.position,
      currentLocation: formData.location,
      totalExperience: formData.experience,
      resume: {
        filename: formData.resumeFileName,
        data: pdfData,
        contentType: formData.resumeContentType,
      },
  };

    try {
      const response = await fetch(
        "https://b5alx6fvg8.execute-api.us-east-1.amazonaws.com/ses/careerSubmit",
        {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      setShowSuccessMessage(true); // Show snackbar immediately

      if (!response.ok) {
        setShowSuccessMessage(true);

        setTimeout(() => {
          setShowSuccessMessage(false);
          if (fileUploadRef.current) {
            fileUploadRef.current.clear();
          }
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            location: "",
            position: "",
            experience: "",
            base64Data: "",
            resumeFileName: "",
            resumeContentType: "",
          });
          setErrorData("");
          setPdfData("");
          setIsSubmitting(false); // Unlock for next attempt (after form reset)
        }, 3000);
      }

      if (!response.ok) {
        const errorText = await response.text();
        console.error("HTTP Error: ", response.status, errorText);
        throw new Error(`HTTP Error: ${response.status} ${errorText}`);
      }
    } catch (error) {
      console.error("Error during fetch: ", error);
      setIsSubmitting(false); // Allow retry on error
    }
  };

  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Careers</title>
        <meta
          name="description"
          content="Explore exciting career opportunities to propel your skills and expertise."
        />
        <link rel="canonical" href="https://www.althisolutions.com/careers" />
        <meta name="robots" content="index, follow" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Careers" />
        <meta
          property="og:url"
          content="https://www.althisolutions.com/careers"
        />
        <meta
          property="og:image"
          content="https://althisolutions.com/static/media/BannerImg.2ea4a0ebd04be850829e.jpg"
        />
        <meta
          property="og:description"
          content="Explore exciting career opportunities to propel your skills and expertise."
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Careers" />
        <meta name="twitter:site" content="@Althisolutions" />
        <meta
          name="twitter:description"
          content="Explore exciting career opportunities to propel your skills and expertise."
        />
        <meta
          name="twitter:image"
          content="https://althisolutions.com/static/media/BannerImg.2ea4a0ebd04be850829e.jpg"
        />
      </Helmet>

      <Nav />

      <div className="career-page aln_Pos" style={{ height: "auto" }}>
        <div className="w-full max_Width pa_TB">
          <div
            className="career-page-text flex flex_D g_15"
            style={{ alignItems: "flex-start" }}
          >
            <h2>
              JOIN OUR PACK<span>.</span>
            </h2>
            <p>
              We help organizations across the globe achieve digital
              transformation.
            </p>
          </div>

          <div className="career-page-form">
            <div className="contactus-section-banner-form">
              <div className="contactus-form-career">
                <form onSubmit={handleSubmit}>
                  <div className="field col">
                    <label>First Name</label>
                    <InputText
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      className="p-inputtext-sm w-full"
                      required
                    />
                  </div>
                  <div className="field col">
                    <label>Last Name</label>
                    <InputText
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      className="p-inputtext-sm w-full"
                    />
                  </div>
                  <div className="field col">
                    <label>Email</label>
                    <InputText
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="p-inputtext-sm w-full"
                      required
                    />
                  </div>
                  <div className="flex col w-max">
                    <div className="field col-6 pl-0">
                      <label>Phone Number</label>
                      <InputMask
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        className="p-inputtext-sm w-full"
                        mask="9999999999"
                        required
                      ></InputMask>
                    </div>
                    <div className="field col-6 pr-0">
                      <label>Current Location</label>
                      <InputText
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        className="p-inputtext-sm w-full"
                        required
                      />
                    </div>
                  </div>
                  <div className="field col">
                    <label>Applying For</label>
                    <InputText
                      type="text"
                      name="position"
                      value={formData.position}
                      onChange={handleChange}
                      className="p-inputtext-sm w-full"
                      required
                    />
                  </div>
                  <div className="field col">
                    <label>Total Experience (In Years)</label>
                    <InputText
                      type="number"
                      name="experience"
                      value={formData.experience}
                      onChange={handleChange}
                      className="p-inputtext-sm w-full"
                      required
                    />
                  </div>

                  <div className="submit-btn">
                    <FileUpload
                      ref={fileUploadRef}
                      mode="basic"
                      name="demo[]"
                      accept=".pdf,.doc,.docx"
                      maxFileSize={1000000}
                      onSelect={onSelect}
                      chooseLabel="Upload Your Resume"
                      value={formData.base64Data}
                      required
                    />

                    <Button
                      className="submit-button"
                      type="submit"
                      disabled={isSubmitting} // NEW
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </Button>
                  </div>
                  <div className="grid justify-content-center">
                    {errorData && <p className="error-msg">{errorData}</p>}
                  </div>

                  {showSuccessMessage && (
                    <div className="success-messages">
                      <div className="success-message-contents">
                        <div className="success-message-headings">
                          Submitted Successfully !
                        </div>
                        <AiOutlineCheckCircle className="check-icon"></AiOutlineCheckCircle>
                      </div>
                    </div>
                  )}
                </form>
              </div>
              <div className="career-page-form-content flex">
                <p style={{ textAlign: "justify" }}>
                  Beyond jobs, we open the doors for your growth
                  <span>.</span> &nbsp;
                  <span>Are you up for the Journey?</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CareerPage;
